import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchMenu = async () => {
  const { data } = await api.get("/menu");
  return data;
};

export const fetchContent = async () => {
  const { data } = await api.get("/content");
  return data;
};

export const fetchGallery = async () => {
  const { data } = await api.get("/gallery");
  return data;
};

export const fetchReviews = async () => {
  const { data } = await api.get("/reviews");
  return data;
};

export const fetchMerch = async () => {
  const { data } = await api.get("/merch");
  return data;
};

export const adminUpdateMerchSettings = async (payload, token) => {
  const { data } = await api.put("/admin/merch/settings", payload, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminCreateMerchProduct = async (payload, token) => {
  const { data } = await api.post("/admin/merch/products", payload, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminUpdateMerchProduct = async (itemId, payload, token) => {
  const { data } = await api.put(`/admin/merch/products/${itemId}`, payload, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminDeleteMerchProduct = async (itemId, token) => {
  const { data } = await api.delete(`/admin/merch/products/${itemId}`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

// ===== Admin content writes =====
export const adminUpdateContent = async (payload, token) => {
  const { data } = await api.put("/admin/content", payload, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminCreateGallery = async (payload, token) => {
  const { data } = await api.post("/admin/gallery", payload, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminUpdateGallery = async (itemId, payload, token) => {
  const { data } = await api.put(`/admin/gallery/${itemId}`, payload, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminDeleteGallery = async (itemId, token) => {
  const { data } = await api.delete(`/admin/gallery/${itemId}`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminCreateReview = async (payload, token) => {
  const { data } = await api.post("/admin/reviews", payload, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminUpdateReview = async (itemId, payload, token) => {
  const { data } = await api.put(`/admin/reviews/${itemId}`, payload, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminDeleteReview = async (itemId, token) => {
  const { data } = await api.delete(`/admin/reviews/${itemId}`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const createCheckoutSession = async (payload) => {
  const { data } = await api.post("/checkout/session", payload);
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await api.get(`/checkout/status/${sessionId}`);
  return data;
};

export const adminLogin = async (password, email) => {
  const { data } = await api.post("/admin/login", { password, email });
  return data;
};

export const adminListOrders = async (token) => {
  const { data } = await api.get("/admin/orders", {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminUpdateStatus = async (orderId, status, password) => {
  const { data } = await api.post(`/admin/orders/${orderId}/status`, {
    password,
    status,
  });
  return data;
};

// ===== Menu CMS =====
export const adminListMenu = async (token) => {
  const { data } = await api.get("/admin/menu", {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminCreateMenuItem = async (payload, token) => {
  const { data } = await api.post("/admin/menu", payload, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminUpdateMenuItem = async (itemId, payload, token) => {
  const { data } = await api.put(`/admin/menu/${itemId}`, payload, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminDeleteMenuItem = async (itemId, token) => {
  const { data } = await api.delete(`/admin/menu/${itemId}`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const adminUploadImage = async (file, token) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/admin/upload", form, {
    headers: { "X-Admin-Token": token, "Content-Type": "multipart/form-data" },
  });
  return data;
};

// Helper: build the absolute URL for an image url returned by the backend.
// Backend-served images come back as "/api/uploads/...". Frontend-served assets are "/assets/..." or absolute URLs.
export const resolveImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};
